module.exports = __webpack_public_path__ + "img/20200507_131629.992aa4bc.jpg";